import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@projeccions-pdc/react-icon';
import LocalizedStrings from './localization.js';
import './css/library.css';
import { libraryStyle } from './stylesParser';
import HomeController from './HomeController';
import StoreController from '@projeccions-pdc/frontend-storage';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import AppContext from '../../AppContext.js';

const styles = theme => ({
    root: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
});

class LibraryHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bookmarks: [],
            sessions: [],
            mostUsedFiles: [],
        };

        //CONTROLLER DECLARATION
        let appContext = new AppContext();
        let platformId = appContext.getPlatformId();
        let myInfo = appContext.getMyInfo();
        let userSub = myInfo ? myInfo.userSub : 'userAnonim';

        this._storeController = new StoreController(platformId, userSub);
        this._homeController = new HomeController(this, this._storeController);
    }

    componentDidMount() {
        this._homeController.listAllBookmarks();
        this._homeController.listAllSessions();
        this._homeController.listMostUsedFiles();


    }

    handlePick = (selectedFile) => {
        if (this.onPickFiles) {
            let results = [];
            results.push(selectedFile);
            this.onPickFiles(results);
        }
    }

    onPickFiles = (pickedObjects) => {
        // console.log('holaaaaaaaaa',pickedObjects)
        this._homeController.processPickedFiles(pickedObjects);
        this.props.onPickFiles(pickedObjects);
    }

    removeBookmark = (bookmarkName) => {
        // console.log('delete ' + bookmarkName);
        this._homeController.removeBookmark(bookmarkName);
    }

    loadBookmark = (bookmarkName) => {
        this.state.bookmarks.forEach((bookmark) => {
            if (bookmark.name === bookmarkName) {
                return this.props.handleLoadBookmark(bookmark);
            }
        });
    }

    render() {
        let searchFiltersComponents = [];
        this.state.bookmarks.forEach((bookmark) => {
            searchFiltersComponents = searchFiltersComponents.concat(
                <Bookmark
                    key={bookmark.name}
                    bookmarkName={bookmark.name}
                    handleDeleteBookmark={this.removeBookmark}
                    handleLoadBookmark={this.loadBookmark}
                />
            );
        });

        const sessionsComponents = this.state.sessions.map((session) => (
            <Session key={session.id} sessionId={session.id} sessionDate={session.date} handleLoadSession={this.props.handleLoadSession} />
        ));

        //
        let filesComponents = '';
        if (this.props.isPicker) {
            let sortedData = [];

            if (this.props.pickerPreFilters && this.props.pickerPreFilters.fileType !== undefined) {
                //console.log(this.state.mostUsedFiles);
                //console.log('filtering');
                sortedData = this.state.mostUsedFiles.filter((element) => {
                    return element.file.fileType === this.props.pickerPreFilters.fileType;
                });
                //console.log(sortedData);
            } else {
                sortedData = this.state.mostUsedFiles;
            }

            sortedData = sortedData.sort((a, b) => {
                return a.count < b.count ? -1 : a.count > b.count ? 1 : 0;
            });

            sortedData = sortedData.reverse();
            sortedData = sortedData.slice(0, 5);
            filesComponents = sortedData.map((fileEntry) => (
                <div key={fileEntry.file.fileId} className={libraryStyle.homeMostUsedFile} onClick={() => { this.handlePick(fileEntry.file); }}>
                    <div className={libraryStyle.homeMostUsedFileField}><b>{fileEntry.file.filename}</b></div>
                    <div className={libraryStyle.homeMostUsedFileField}>{new Date(fileEntry.file.dateCreated).toLocaleString()}</div>
                    <div className={libraryStyle.homeMostUsedFileField}>{LocalizedStrings.usedCount + ' ' + fileEntry.count}</div>
                </div>
            ));
        }

        return (
            <div>

                {this.props.isPicker ?
                    <Paper className={this.props.classes.root} elevation={2}>
                        <h3>{LocalizedStrings.mostUsedFiles}</h3>
                        <div>
                            {filesComponents}
                        </div>
                    </Paper>
                    : ''}
                <Paper className={this.props.classes.root} elevation={2}>
                    <h3>{LocalizedStrings.savedSearches}</h3>
                    <div>
                        {searchFiltersComponents}
                    </div>
                </Paper>
                <Paper className={this.props.classes.root} elevation={2}>
                    <h3>{LocalizedStrings.sessions}</h3>
                    <div>
                        {sessionsComponents}
                    </div>
                </Paper>

            </div>
        );
    }
}
LibraryHome.propTypes = {
    handleLoadBookmark: PropTypes.func.isRequired,
    handleLoadSession: PropTypes.func.isRequired,
    isPicker: PropTypes.bool.isRequired,
    pickerPreFilters: PropTypes.object,
    onPickFiles: PropTypes.func,
    classes: PropTypes.object.isRequired,
};

class Bookmark extends Component {
    constructor(props) {
        super(props);
        this.deleteBookmark = this.deleteBookmark.bind(this);
        this.loadBookmark = this.loadBookmark.bind(this);
    }

    deleteBookmark(e) {
        this.props.handleDeleteBookmark(this.props.bookmarkName);
    }

    loadBookmark(e) {
        this.props.handleLoadBookmark(this.props.bookmarkName);
    }

    render() {
        return (
            <Chip
                style={{ margin: '5px' }}
                avatar={
                    <Avatar>
                        <Icon name='fa-star' />
                    </Avatar>
                }
                label={this.props.bookmarkName}
                onClick={this.loadBookmark}
                onDelete={this.deleteBookmark}
            />

        );
    }
};
Bookmark.propTypes = {
    handleDeleteBookmark: PropTypes.func.isRequired,
    handleLoadBookmark: PropTypes.func.isRequired,
    bookmarkName: PropTypes.string.isRequired
};

class Session extends Component {
    constructor(props) {
        super(props);
        this.loadSession = this.loadSession.bind(this);
    }

    loadSession(e) {
        this.props.handleLoadSession(this.props.sessionId);
    }

    render() {
        return (
            <Chip
                style={{ margin: '5px' }}
                label={new Date(this.props.sessionDate).toLocaleString()}
                onClick={this.loadSession}
                clickable
            />
        );
    }
};
Session.propTypes = {
    handleLoadSession: PropTypes.func.isRequired,
    sessionId: PropTypes.string.isRequired,
    sessionDate: PropTypes.string.isRequired,
};

export default withStyles(styles)(LibraryHome);